<template>
	<div>
		<div class="searchTop topSearch space_between">
			<el-form inline class="el-form">
				<el-form-item>
					<el-select v-model="queryApi.mediaCompany" filterable clearable size="small" placeholder="请选择媒体公司"
					@change="companySelectChange">
						<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.platformId" filterable clearable size="small" @change="networkOptionsChange" placeholder="请选择广告网络">
						<el-option v-for="item in networkOptions" :key="item.platformId" :label="item.label" :value="item.platformId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.platformNetworkId" filterable clearable size="small"
					placeholder="请选择账号名称">
						<el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.os" filterable clearable size="small" placeholder="请选择操作系统">
						<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
						<el-select v-model="appSelectForm" clearable @change="appSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable placeholder="请选择应用"
							:remote-method="appRemoteMethod" :loading="appRemoteLoading" remote @clear="getMediaAppOption()">
							<el-option v-for="item in mediaAppOptions" :key="item.value"
								:value="item" :label="`应用：${item.label} | ${item.value}`">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.type" filterable clearable size="small" placeholder="请选择广告类型">
						<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="adsSelectFormChannel" clearable @change="channelAdsSeleteChange" size="small"
					value-key="value" popper-class="appNameIdOptions" :popper-append-to-body="false" filterable
					@clear="getChannelAdsOption(2)" :remote-method="channelAdsRemoteMethod" :loading="adsRemoteLoading" remote
					placeholder="请选择广告源" style="width: 280px;">
							<el-option v-for="(item,index) in channelAdsOptions" :key="index" :label="`广告源：${item.label} | ${item.value}`"
								:value="item">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.appProperty" clearable size="small" placeholder="请选择应用属性">
						<el-option v-for="item in appPropertyOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div class="menu-right">
					<el-button @click="searchReset" size="small">重置</el-button>
					<div></div>
					<el-button type="primary" @click="apiQuery" size="small"> 查询</el-button>
				</div>
		</div>
		<div class="card chart-card">
			<div class="chartTitRow">
				<div class="chartTitle">数据图表</div>
				<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" type="dates"
					placeholder="选择日期（最多三天）" size="small" :clearable="false"
					:picker-options="datePickerOptions" @change="handleDateChange"
					style="margin-left: auto;width: 360px;">
				</el-date-picker>
				<div class="splitTimePicker">时段</div>
				<el-time-picker
					:clearable="false"
					size="small"
				  is-range
				  v-model="dateTimeStartPicker"
					value-format="HH:mm:ss"
					format="HH:mm:ss"
				  range-separator="至"
				  start-placeholder="开始时段"
				  end-placeholder="结束时段"
				  placeholder="选择时间范围" style="width: 260px;">
				</el-time-picker>
				<!-- <div class="splitTimePicker">结束时段</div>
				<el-time-picker
					:clearable="false"
					size="small"
				  is-range
				  v-model="dateTimeEndPicker"
					value-format="HH:mm:ss"
					format="HH:mm:ss"
				  range-separator="至"
				  start-placeholder="开始时段"
				  end-placeholder="结束时段"
				  placeholder="选择时间范围" style="width: 260px;">
				</el-time-picker> -->
				<el-select v-model="chartQueryData.chartColumnChecked" size="small" style="margin-left: 15px;" @change="fetchChartData">
					<el-option v-for="item in chartColumnOptions" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div ref="timeShareChart" class="chart-box"></div>
		</div>
		<div class="card-table">
			<div class="menu-right-table">
				<div class="tHeadleftTips">查看维度</div>
				<el-checkbox :indeterminate="isDimensionIndeterminate" v-model="dimensionCheckAll" @change="handleCheckAllChangeDim"
					style="margin-right: 30px;">全选</el-checkbox>
					<el-checkbox-group v-model="tHeaderQueryChecked" class="tHeadFixedCheckList">
						<el-checkbox v-for="(item,index) in tHeaderQueryData" :label="item.valueNum" size="mini"
							:checked="item.checked" :key="index" :name="item.value" class="check-box-fixed"
							@change="checkBoxQueryChange($event,item,index)">{{item.label}}
						</el-checkbox>
					</el-checkbox-group>
				<el-button type="primary" size="small" style="margin-right: 10px;margin-left: auto;" @click="exportToExcelFromDOM">导出</el-button>
				<el-popover trigger="click" width="500">
					<div class="table-header-config">
						<div class="table-header-config-toolbar">
							<el-checkbox
								v-model="headerSelectAll"
								:indeterminate="headerIndeterminate"
							>全选</el-checkbox>
						</div>
						<div class="table-header-config-item" v-for="item in tHeadHeaderConfigList" :key="item.prop">
							<el-checkbox v-model="item.checked" @change="handleHeaderChange">{{ item.label }}</el-checkbox>
						</div>
					</div>
					<template slot="reference">
						<el-button type="primary" size="small">表头配置</el-button>
					</template>
				</el-popover>
			</div>
			<el-table :max-height="560" :data="tableData" class="el_table"
				:header-cell-style="{color:'#666666',background:'#F7F8F9'}"
				ref="multipleTable" @sort-change="sortChangeFun" :header-cell-class-name="handleHeadAddClass">
				<el-table-column prop="platformName" label="广告网络" min-width="90"
					v-if="tHeaderQueryChecked.indexOf(8) !== -1"></el-table-column>
				<el-table-column prop="os" label="操作系统" min-width="90"
					v-if="tHeaderQueryChecked.indexOf(3) !== -1"></el-table-column>
				<el-table-column prop="mediaAppId" label="应用" min-width="160"
					v-if="tHeaderQueryChecked.indexOf(4) !== -1">
					<template slot-scope="scope">
						<div v-if="scope.row.platformAppId">
							<div>{{scope.row.platformAppName}}</div>
							<div style="color: #4F7AFD;">{{scope.row.platformAppId}}</div>
						</div>
						<div v-else>-</div>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="广告位类型" min-width="100"
					v-if="tHeaderQueryChecked.indexOf(5) !== -1"></el-table-column>
				<el-table-column label="广告源" min-width="180" v-if="tHeaderQueryChecked.indexOf(9) !== -1">
					<template slot-scope="scope">
						<div v-if="scope.row.platformAdId">
							<div>{{scope.row.platformAdName}}</div>
							<div style="color: #4F7AFD;">{{scope.row.platformAdId}}</div>
						</div>
						<div v-else>-</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="时间" min-width="180" align="center">
					<template slot-scope="scope">
						<div v-if="Array.isArray(scope.row.timeRange)&&scope.row.timeRange.length>0">
							<div
								v-for="(t, idx) in scope.row.timeRange"
								:key="idx"
								class="updownText"
								:class="{ mgb0: idx === scope.row.timeRange.length - 1 }"
							>{{ t }}</div>
						</div>
						<div v-else-if="!Array.isArray(scope.row.timeRange) && scope.row.timeRange">{{ scope.row.timeRange }}</div>
						<div v-else>-</div>
					</template>
				</el-table-column>
				<template v-for="columnObj in visibleTHeadList">
					<el-table-column :prop="columnObj.prop" :label="columnObj.label" align="center"
						:width="columnObj.width"
						:min-width="columnObj.minWidth"
						:fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false" :key="columnObj.prop">
						<template v-slot="scope">
							<slot :name="columnObj.prop" :scope="scope">
								<div v-if="Array.isArray(scope.row[columnObj.prop]) && scope.row[columnObj.prop].length">
									<div
										v-for="(cellVal, idx) in scope.row[columnObj.prop]"
										:key="idx"
										class="updownText"
										:class="{ mgb0: idx === scope.row[columnObj.prop].length - 1 }"
									>{{ formatCellForMetric(cellVal, columnObj.label) }}</div>
								</div>
								<div v-else-if="hasScalarMetricCell(scope.row, columnObj.prop)">
									{{ formatCellForMetric(scope.row[columnObj.prop], columnObj.label) }}
								</div>
								<div v-else>-</div>
							</slot>
						</template>
					</el-table-column>
				</template>
			</el-table>
			<div class="paging">
				<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 30, 500]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from "echarts";
	import * as XLSX from 'xlsx';

	/**
	 * 折线图每条序列对应的主题色（最多与服务端 7 日 series 下标对齐）。
	 */
	const CHART_LINE_COLORS = [
		"#20B2AA",
		"#007FFF",
		"#FF6B6B",
		"#A855F7",
		"#F59E0B",
		"#10B981",
		"#6366F1",
	]

	export default {
		data() {
			return {
				queryApi: {
					isMedia: false,
					platformNetworkId: '',
					platformAdsId: '',
					mediaAppId: '',
					mediaCompany: '',
					os: '',
					type: '',
					pageNum: 1,
					pageSize: 10,
					appProperty: ''
				},
				isDimensionIndeterminate: false,
				dimensionCheckAll: true,
				datePicker: [],
				// 禁止未来日期，并在选满三天后只允许取消已选日期
				datePickerOptions: {},
				companyOptions: [], //公司下拉选择列表
				osOptions: this.$api.osOptions, // OS下拉选择列表
				mediaAppOptions: [], // 媒体APP下拉选择列表
				appSelectForm: {}, // 媒体APP下拉选中值
				appRemoteLoading: false,
				adTypeOptions: this.$api.adsTypeOptions, // 广告类型
				appPropertyOptions: this.$api.appPropertyOptions, // 应用属性下拉选择列表

				adsSelectFormChannel: {}, //渠道广告位下拉选中数据
				channelAdsOptions: [], //渠道广告位下拉列表
				adsRemoteLoading: false,

				networkOptions: [], // 广告网络下拉列表
				accountOptions: [], // 账号名称下拉选择列表

				dateStartPicker: '',
				dateTimeStartPicker: [],
				dateEndPicker: '',
				dateTimeEndPicker: null,
				chartQueryData: {
					chartColumnChecked: 'estimateProfit',
				},

				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				// 表格排序数据
				sortField: {},
				// 表格列 prop -> 服务端 orderField 的映射（需要自定义时在这里配置）
				// 例如：{ firstRequestNum: 'firstRequestCount' }
				// 注意：只有“请求数/收益”需要排序，这里给出 prop -> 后端 orderField 映射
				// 与 channelData 一致：默认按列 prop 作为 orderField，若有差异在此映射
				sortPropToOrderField: {},
				orderBys: [],

				tHeadCheckedList: [],
				// 与 channelData.vue tHeadAllList 各分组的 list（二级）顺序一致，字段与 channel 内层项一致（无 secondProp）
				tHeadNormalCheckedList: [
					{
						prop: 'channelEstimateProfit',
						label: '总收益(¥)',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'estimateProfit',
						label: '媒体收益(¥)',
						checked: true,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'divideEstimateProfit',
						label: '分成收益(¥)',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'reqNum',
						label: '广告请求量',
						checked: false,
						sortable: false,
						minWidth: '120',
					},
					{
						prop: 'succNum',
						label: '广告返回量',
						checked: false,
						sortable: false,
						width: '120',
					},
					{
						prop: 'succReqRate',
						label: '广告填充率',
						checked: false,
						sortable: false,
						width: '120',
					},
					{
						prop: 'showNum',
						label: '广告展示量',
						checked: true,
						sortable: false,
						width: '120',
					},
					{
						prop: 'succShowRate',
						label: '广告展示率',
						checked: false,
						sortable: false,
						width: '120',
					},
					{
						prop: 'clickNum',
						label: '广告点击量(未去重)',
						checked: false,
						sortable: false,
						width: '150',
					},
					{
						prop: 'uniqueClickNum',
						label: '广告点击量(去重)',
						checked: false,
						sortable: false,
						width: '140',
					},
					{
						prop: 'deductClickNum',
						label: '广告点击量(扣量后)',
						checked: true,
						sortable: false,
						width: '150',
						temp: true,
					},
					{
						prop: 'clickRate',
						label: '广告点击率(未去重)',
						checked: false,
						sortable: false,
						width: '150',
						temp: true,
					},
					{
						prop: 'uniqueClickRate',
						label: '广告点击率(去重)',
						checked: false,
						sortable: false,
						width: '150',
						temp: true,
					},
					{
						prop: 'deductClickRate',
						label: '广告点击率(扣量后)',
						checked: false,
						sortable: false,
						width: '150',
						temp: true,
					},
					{
						prop: 'channelEcpm',
						label: '总收益eCPM(¥)',
						checked: false,
						sortable: false,
						minWidth: '140',
					},
					{
						prop: 'ecpm',
						label: '媒体收益eCPM(¥)',
						checked: true,
						sortable: false,
						width: '140',
					},
					// {
					// 	prop: 'apiIncome',
					// 	label: 'API收益',
					// 	checked: true,
					// 	sortable: false,
					// 	width: '140',
					// },
					// {
					// 	prop: 'apiReqNum',
					// 	label: 'API请求量',
					// 	checked: true,
					// 	sortable: false,
					// 	width: '140',
					// },
					// {
					// 	prop: 'apiSuccNum',
					// 	label: 'API返回量',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '140',
					// },
					// {
					// 	prop: 'apiSuccRate',
					// 	label: 'API填充率',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '140',
					// },
					// {
					// 	prop: 'apiShowNum',
					// 	label: 'API展示量',
					// 	checked: true,
					// 	sortable: false,
					// 	width: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'apiUniqueClickNum',
					// 	label: 'API点击量(去重)',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '140',
					// },
					// {
					// 	prop: 'apiDeductClickNum',
					// 	label: 'API点击量(扣量后)',
					// 	checked: true,
					// 	sortable: false,
					// 	width: '140',
					// 	temp: true,
					// },
					// {
					// 	prop: 'apiUniqueClickRate',
					// 	label: 'API点击率(去重)',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '150',
					// 	temp: true,
					// },
					// {
					// 	prop: 'apiDeductClickRate',
					// 	label: 'API点击率(扣量后)',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '150',
					// 	temp: true,
					// },
					// {
					// 	prop: 'apiEcpm',
					// 	label: 'API eCPM(￥)',
					// 	checked: true,
					// 	sortable: false,
					// 	width: '120',
					// },
					// {
					// 	prop: 'reqGapRate',
					// 	label: '请求GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'reqSuccGapRate',
					// 	label: '返回GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'showGapRate',
					// 	label: '展示GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'clickGapRate',
					// 	label: '点击GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'ecpmGapRate',
					// 	label: 'eCPM GAP率',
					// 	checked: false,
					// 	sortable: false,
					// 	width: '120',
					// 	temp: true,
					// },
					// {
					// 	prop: 'incomeGapRate',
					// 	label: '收益GAP率',
					// 	checked: true,
					// 	sortable: false,
					// 	width: '120',
					// 	temp: true,
					// },
				],
				tHeadStorageKey: 'sdk-timeShareReport-budgetDimension-tHead',
				// 表头列结构（prop 增删、合并规则）变更时递增，会触发与本地缓存重新对齐
				tHeadSchemaVersion: 3,

				tHeaderQueryChecked: [8, 3, 4, 5, 9],
				tHeaderQueryData: [
					{value: 'platformNetworkId', valueNum: 8, label: "广告网络", checked: false},
					{value: 'os', valueNum: 3, label: "操作系统", checked: false},
					{value: 'mediaAppId', valueNum: 4, label: "应用", checked: false},
					{value: 'type', valueNum: 5, label: "广告位类型", checked: false},
					{value: 'platformAdId', valueNum: 9, label: "广告源", checked: false},
				],
			}
		},
		computed: {
			// 表头配置：与 channelData tHeadAllList 二级列一致的可勾选列
			tHeadHeaderConfigList() {
				return this.tHeadCheckedList
			},
			visibleTHeadList() {
				return this.tHeadCheckedList.filter((col) => col.checked !== false)
			},
			headerIndeterminate() {
				const mains = this.tHeadCheckedList
				if (!mains.length) return false
				const n = mains.filter((i) => i.checked).length
				return n > 0 && n < mains.length
			},
			headerSelectAll: {
				get() {
					const mains = this.tHeadCheckedList
					if (!mains.length) return false
					return mains.every((i) => i.checked)
				},
				set(val) {
					this.tHeadCheckedList.forEach((m) => {
						m.checked = val
					})
					this.handleHeaderChange()
				},
			},
			// 图表下拉：chartType 与列 prop 一致
			chartColumnOptions() {
				return this.tHeadNormalCheckedList.map((col) => ({ value: col.prop, label: col.label }))
			},
		},
		created() {
			const vm = this
			// 多选日期最多三天；已选日期保持可点，以便用户取消选择。
			this.datePickerOptions = {
				disabledDate(time) {
					const todayStart = new Date()
					todayStart.setHours(0, 0, 0, 0)
					if (time.getTime() > todayStart.getTime()) return true
					const pad = (n) => String(n).padStart(2, '0')
					const date = `${time.getFullYear()}-${pad(time.getMonth() + 1)}-${pad(time.getDate())}`
					return vm.datePicker.length >= 3 && !vm.datePicker.includes(date)
				},
			}
		},
		mounted(){
			this.initTHeadCheckedList()
			// this.chartQueryData['chartColumnChecked'] = this.chartColumnOptions[0].value
			this.getCompanyOption();
			this.getNetworkOtions();
			this.getAccountOptions();
			this.getChannelAdsOption(2, null);
			this.dateInit()
			this.getMediaAppOption();
			this.getTableData()
			this.$nextTick(() => {
				this.fetchChartData()
			})
		},
		methods: {
			// 日期面板确认后按时间升序排列，展示和请求参数使用同一顺序。
			handleDateChange(dates) {
				if (Array.isArray(dates)) this.datePicker = dates.slice().sort()
			},
			// 日期选择器初始化：默认昨天和今天；可独立选择最多三天；时段默认全天。
			dateInit() {
				this.datePicker = []
				const pad = (n) => String(n).padStart(2, '0')
				const formatYmd = (d) =>
					`${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
				const now = new Date()
				const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
				const yesterdayStart = new Date(todayStart)
				yesterdayStart.setDate(yesterdayStart.getDate() - 1)
				this.datePicker.push(formatYmd(yesterdayStart))
				this.datePicker.push(formatYmd(todayStart))
				const defaultDayRange = ['00:00:00', '23:59:59']
				this.dateTimeStartPicker = defaultDayRange
				this.dateTimeEndPicker = defaultDayRange.slice()
			},
			// 维度选择-全选
			handleCheckAllChangeDim(val){
				this.tHeaderQueryChecked = []
				if(val){
					this.tHeaderQueryData.forEach((item) => {
						this.tHeaderQueryChecked.push(item.valueNum)
					})
				}
				this.isDimensionIndeterminate = false;
				this.currentPage = 1
				this.getTableData();
			},
			// 维度选择
			checkBoxQueryChange(e, item, index) {
				this.tHeaderQueryData[index].checked = e
				this.dimensionCheckAll = this.tHeaderQueryChecked.length === this.tHeaderQueryData.length
				this.isDimensionIndeterminate = this.tHeaderQueryChecked.length > 0 &&  this.tHeaderQueryChecked.length < this.tHeaderQueryData.length
				this.currentPage = 1
				this.getTableData();
			},
			// 渠道广告位下拉选中
			channelAdsSeleteChange(e) {
				if (e && e.value) {
					this.adsSelectFormChannel = e
				}
			},
			channelAdsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getChannelAdsOption(2, query)
				}, 300)
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 公司下拉列表选择
			companySelectChange(){
				this.mediaAppOptions = []
				this.getMediaAppOption();
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption(query = null) {
				let data = {
					mediaCompany: this.queryApi.mediaCompany,
					appId: query,
				}
				let res = await this.$http.get(this.$api.common.mediaAppOption,data);
				this.appRemoteLoading = false
				this.mediaAppOptions = res.data
			},
			appSeleteChange(e) {
				this.appSelectForm = e
			},
			appRemoteMethod(query){
				clearTimeout();
				setTimeout(()=>{
					this.appRemoteLoading = true
					this.getMediaAppOption(query)
				},300)
			},
			// 获取渠道广告位下拉列表
			async getChannelAdsOption(type, query = null) {
				let data = {
					adsId: query
				}
				let res = await this.$http.post(this.$api.common.channelAdsOption, data);
				this.adsRemoteLoading = false
				this.channelAdsOptions = res.data
			},
			// 获取配置后的广告网络下拉选择列表
			async getNetworkOtions() {
				let res = await this.$http.get(this.$api.mediaAd.networkOptionDistinct);
				this.networkOptions = res.data
			},
			networkOptionsChange(e){
				this.accountOptions = []
				this.queryApi.platformNetworkId = ''
				if(e){
					this.getAccountOptions(e);
				}else{
					this.getAccountOptions();
				}
			},
			// 获取账号名称下拉列表
			async getAccountOptions(platformId){
				let data = {platformId: platformId}
				let res = await this.$http.get(this.$api.mediaAd.networkAccountOption,data);
				this.accountOptions = res.data
			},
			// 复制APP名称
			async copyName(txt) {
				try {
					// 使用现代异步 API
					await navigator.clipboard.writeText(txt)
					this.$message.success('复制成功');
				} catch (err) {
					// 某些环境（比如 HTTP 或非安全上下文）不支持 navigator.clipboard
					// 这里可做回退方案：
					this.fallbackCopy(txt)
				}
			},
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功');
			},
			formatCell(val) {
				if (val === null || val === undefined || val === '') return '-'
				return val
			},
			labelEndsWithRate(label) {
				if (label == null || label === '') return false
				const s = String(label).trim()
				return s.length > 0 && s[s.length - 1] === '率'
			},
			formatCellForMetric(val, label) {
				const base = this.formatCell(val)
				if (base === '-') return base
				if (!this.labelEndsWithRate(label)) return base
				const s = String(base)
				return s.endsWith('%') ? s : `${s}%`
			},
			buildTimeShareSummaryRow(root) {
				const c =
					root &&
					root.columnTotals &&
					typeof root.columnTotals === "object" &&
					!Array.isArray(root.columnTotals)
						? root.columnTotals
						: {}
				const cell = (v) => (v == null || v === "" ? "-" : v)
				const row = {
					isSummaryRow: true,
					platformName: "合计",
					os: "-",
					type: "-",
				}
				this.tHeadNormalCheckedList.forEach(({ prop }) => {
					row[prop] = cell(c[prop])
				})
				row.timeRange = c.timeRange
				return row
			},
			hasScalarMetricCell(row, prop) {
				const v = row[prop]
				if (v === null || v === undefined || v === "") return false
				return !Array.isArray(v)
			},
			initTHeadCheckedList() {
				const verKey = `${this.tHeadStorageKey}:schemaVer`
				const storedVer = localStorage.getItem(verKey)
				const schemaMismatch = storedVer !== String(this.tHeadSchemaVersion)
				let raw = localStorage.getItem(this.tHeadStorageKey)
				if (!raw) raw = localStorage.getItem('sdk-budgetDataTHead')
				let parsed = []
				if (raw) {
					try {
						parsed = JSON.parse(raw)
					} catch (e) {
						parsed = []
					}
				}
				if (!Array.isArray(parsed)) parsed = []
				let list
				if (!parsed.length) {
					list = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
				} else {
					list = this.mergeTHeadWithDefault(parsed)
				}
				list.forEach((item) => {
					if (item.checked === undefined) item.checked = true
				})
				this.tHeadCheckedList = list
				if (schemaMismatch) {
					localStorage.setItem(verKey, String(this.tHeadSchemaVersion))
				}
				this.persistTHeadCheckedList()
			},
			// 仅以 tHeadNormalCheckedList 为列定义来源；本地只恢复「是否勾选」，避免旧缓存覆盖 label/minWidth/sortable 等
			mergeTHeadWithDefault(saved) {
				const byProp = {}
				saved.forEach((row) => {
					if (row && row.prop) byProp[row.prop] = row
				})
				return this.tHeadNormalCheckedList.map((def) => {
					const old = byProp[def.prop]
					const baseChecked = def.checked !== undefined ? def.checked : true
					const checked =
						old && typeof old.checked === 'boolean' ? old.checked : baseChecked
					return {
						...def,
						checked,
					}
				})
			},
			persistTHeadCheckedList() {
				localStorage.setItem(this.tHeadStorageKey, JSON.stringify(this.tHeadCheckedList))
			},
			handleHeaderChange() {
				this.persistTHeadCheckedList()
				this.$nextTick(() => {
					this.$refs.multipleTable && this.$refs.multipleTable.doLayout()
				})
			},
			appendTimeRangeToPayload(data) {
				const padTime = (arr, idx, fallback) => {
					if (arr && arr.length > idx && arr[idx]) return arr[idx]
					return fallback
				}
				if (this.dateStartPicker) {
					const t0 = padTime(this.dateTimeStartPicker, 0, '00:00:00')
					const t1 = padTime(this.dateTimeStartPicker, 1, '23:59:59')
					data.startTime = `${this.dateStartPicker} ${t0}`
					data.endTime = `${this.dateStartPicker} ${t1}`
				}
				if (this.dateEndPicker) {
					const t0 = padTime(this.dateTimeStartPicker, 0, '00:00:00')
					const t1 = padTime(this.dateTimeStartPicker, 1, '23:59:59')
					data.compareStartTime = `${this.dateEndPicker} ${t0}`
					data.compareEndTime = `${this.dateEndPicker} ${t1}`
				}
			},
			apiQuery() {
				this.currentPage = 1
				this.queryApi.pageNum = 1
				this.getTableData()
				this.fetchChartData()
			},
			// 列表、图表和导出共用：每个已选日期拼接相同的起止时段。
			buildReportQueryBody(overrides) {
				const data = JSON.parse(JSON.stringify(this.queryApi))
				data.timeRanges = this.datePicker.map((date) =>
					`${date} ${this.dateTimeStartPicker[0]}-${this.dateTimeStartPicker[1]}`
				)
				if (this.orderBys && this.orderBys.length) {
					data.adOrderByReqs = this.orderBys
				}
				return Object.assign(data, overrides || {})
			},
			// 列表 / 图表 / 导出共用：把顶部表单里不在 queryApi 上的条件写入请求体（与 getTableData 一致）
			appendTopFilterToReportBody(data) {
				if (this.appSelectForm && this.appSelectForm.value) {
					data.appId = this.appSelectForm.value
				}
				if (this.adsSelectFormChannel && this.adsSelectFormChannel.value) {
					data.platformAdsId = this.adsSelectFormChannel.value
				}
				if (this.tHeaderQueryChecked && this.tHeaderQueryChecked.length > 0) {
					data.groupByIdList = this.tHeaderQueryChecked
				}
			},
			reportQueryTimeReady() {
				return (
					this.datePicker &&
					this.datePicker.length >= 1 &&
					this.dateTimeStartPicker &&
					this.dateTimeStartPicker.length >= 2
				)
			},
			getExportFileNamePrefix() {
				const d = new Date()
				const pad = (n) => String(n).padStart(2, '0')
				return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}:${pad(
					d.getMinutes()
				)}`
			},
			timeDataReportExport() {
				if (!this.reportQueryTimeReady()) {
					this.$message.warning('请先选择日期与时段')
					return
				}
				this.$confirm('此操作将导出当前查询条件下的数据，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(async () => {
						const data = this.buildReportQueryBody({ page: 1, pageSize: 999999 })
						this.appendTopFilterToReportBody(data)
						const prefix = this.getExportFileNamePrefix()
						const res = await this.$http.post(this.$api.dataManage.timeDataReportExport,data,1);
						this.$http.downloads(res, `${prefix}渠道分时报表对比.xlsx`)
					})
					.catch(() => {})
			},
			async getTableData() {
				if (!this.reportQueryTimeReady()) {
					return
				}
				let data = this.buildReportQueryBody();
				this.appendTopFilterToReportBody(data)
				let res = await this.$http.post(this.$api.dataManage.timeDataReportListChannel,data);
				if (res.code == 200||res.code == 1) {
					const d = res.data || {}
					const list = [...(d.list || [])]
					if (list.length) list.unshift(this.buildTimeShareSummaryRow(d))
					this.tableData = list
					this.total = d.totalSeries
				}
			},
			getChartMetricLabel() {
				const t = this.chartQueryData.chartColumnChecked
				const opt = this.chartColumnOptions.find((o) => o.value === t)
				return opt ? opt.label : '指标'
			},
			// 折线图例/提示：日期 + 时段（与查询条件一致，如 2024-10-09 0~8）
			buildChartPeriodLabel(periodIndex) {
				if (!this.datePicker || !this.datePicker[periodIndex]) {
					return periodIndex === 0 ? '第一时段' : '第二时段'
				}
				const date = this.datePicker[periodIndex]
				const t = this.dateTimeStartPicker
				if (!t || t.length < 2) return date
				const p0 = String(t[0]).split(':')
				const p1 = String(t[1]).split(':')
				const h0 = parseInt(p0[0], 10)
				const h1 = parseInt(p1[0], 10)
				if (Number.isNaN(h0) || Number.isNaN(h1)) return date
				return `${date} ${h0}~${h1}`
			},
			renderEmptyChart() {
				const el = this.$refs.timeShareChart
				if (!el) return
				if (echarts.getInstanceByDom(el)) echarts.dispose(el)
				const chart = echarts.init(el)
				chart.setOption({
					tooltip: {
						trigger: 'axis',
						backgroundColor: '#fff',
						padding: 10,
						borderColor: '#E4E7ED',
						borderWidth: 1,
						textStyle: { color: '#303133', fontSize: 12 },
						extraCssText: 'box-shadow: 0 2px 12px 0 rgba(0,0,0,0.12);',
					},
					grid: { left: '4%', right: '4%', top: '14%', bottom: '6%' },
					xAxis: { type: 'category', data: [] },
					yAxis: [
						{
							type: 'value',
							splitLine: { lineStyle: { type: 'dashed', color: '#DFE6F2' } },
						},
					],
					series: [],
				})
			},
			resolveChartLegendNames(d, count, embeddedNames) {
				if (Array.isArray(embeddedNames) && embeddedNames.length === count) {
					return embeddedNames.map((n, i) => (n != null && n !== '' ? String(n) : `系列${i + 1}`))
				}
				const nameKeys = ['seriesNames', 'legendNames', 'legend', 'dayLabels', 'names', 'dates']
				for (let k = 0; k < nameKeys.length; k++) {
					const arr = d[nameKeys[k]]
					if (!Array.isArray(arr) || !arr.length) continue
					return Array.from({ length: count }, (_, i) => {
						const v = arr[i]
						return v != null && v !== '' ? String(v) : `系列${i + 1}`
					})
				}
				// 服务端未返回图例时，按已选日期标注对应的折线。
				if (count === this.datePicker.length) {
					return this.datePicker.map((_, i) => this.buildChartPeriodLabel(i))
				}
				return Array.from({ length: count }, (_, i) => `系列${i + 1}`)
			},
			normalizeChartSeriesArrays(d) {
				if (!d || typeof d !== "object") return { list: [], legacyTwoLine: false, embeddedNames: null }
				const series = d.series
				if (
					Array.isArray(series) &&
					series.length > 0 &&
					series.every((row) => Array.isArray(row))
				) {
					return { list: series, legacyTwoLine: false, embeddedNames: null }
				}
				const first = Array.isArray(d.first) ? d.first : []
				const second = Array.isArray(d.second) ? d.second : []
				if (first.length || second.length) {
					return { list: [first, second], legacyTwoLine: true, embeddedNames: null }
				}
				return { list: [], legacyTwoLine: false, embeddedNames: null }
			},
			applyChartOption(d) {
				const el = this.$refs.timeShareChart
				if (!el) return
				const tooltipBase = {
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: 10,
					borderColor: '#E4E7ED',
					borderWidth: 1,
					textStyle: { color: '#303133', fontSize: 12 },
					extraCssText: 'box-shadow: 0 2px 12px 0 rgba(0,0,0,0.12);',
				}
				const ySplitLine = { lineStyle: { type: 'dashed', color: '#DFE6F2' } }
				const pctLabel = (v) => {
					if (v == null || v === '') return ''
					const s = String(v)
					return s.endsWith('%') ? s : `${s}%`
				}
				const tooltipValue = (v, rate) => {
					if (v == null || v === '') return '-'
					return rate ? pctLabel(v) : v
				}
				const tooltipFormatter = (metricName, rate) => (params) => {
					if (!params || !params.length) return ''
					const tc = '#303133'
					let html = `<div style="font-weight:600;margin-bottom:8px;color:${tc};">${metricName}</div>`
					for (const p of params) {
						html += `<div style="display:flex;align-items:center;justify-content:space-between;min-width:200px;margin:4px 0;color:${tc};">
							<span>${p.marker}<span style="margin-left:6px;">${p.seriesName}</span></span>
							<span style="font-weight:500;color:${p.color};margin-left:16px;">${tooltipValue(p.value, rate)}</span>
						</div>`
					}
					return html
				}
				if (echarts.getInstanceByDom(el)) echarts.dispose(el)
				const chart = echarts.init(el)
				const xData = (d.hourTime || []).map((h) => (h != null && h !== '' ? String(h) : ''))
				const { list: rows, legacyTwoLine, embeddedNames } = this.normalizeChartSeriesArrays(d)
				const metric = this.getChartMetricLabel()
				const isRate = this.labelEndsWithRate(metric)
				let names = this.resolveChartLegendNames(d, rows.length, embeddedNames)
				if (legacyTwoLine && rows.length === 2 && this.datePicker.length === 2) {
					names = [this.buildChartPeriodLabel(1), this.buildChartPeriodLabel(0)]
				}
				const n = rows.length
				const legendBottom = n > 3 ? '12%' : '4%'
				const gridBottom = n > 3 ? '22%' : '16%'
				const colorLast = CHART_LINE_COLORS.length - 1
				const series = rows.map((data, idx) => ({
					name: names[idx],
					type: 'line',
					smooth: 0.5,
					data,
					itemStyle: { color: CHART_LINE_COLORS[Math.min(idx, colorLast)] },
				}))
				chart.setOption({
					tooltip: {
						...tooltipBase,
						axisPointer: { type: 'line' },
						formatter: tooltipFormatter(metric, isRate),
					},
					legend: { type: 'scroll', data: names, bottom: legendBottom },
					grid: { left: '6%', right: '3%', top: '14%', bottom: gridBottom },
					xAxis: { type: 'category', boundaryGap: false, data: xData },
					yAxis: [
						{
							type: 'value',
							name: metric,
							nameTextStyle: { color: '#666666', fontSize: 12 },
							splitLine: ySplitLine,
							axisLabel: isRate ? { formatter: pctLabel } : {},
						},
					],
					series,
				})
			},
			async fetchChartData() {
				if (!this.reportQueryTimeReady()) {
					this.renderEmptyChart()
					return
				}
				const chartType = this.chartQueryData.chartColumnChecked
				if (chartType == null || chartType === '') {
					this.renderEmptyChart()
					return
				}
				const data = this.buildReportQueryBody({
					metric: chartType,
				})
				this.appendTopFilterToReportBody(data)
				try {
					const res = await this.$http.post(this.$api.dataManage.timeDataReportChart,data);
					if ((res.code == 200 || res.code == 1) && res.data) {
						this.applyChartOption(res.data)
					} else {
						this.renderEmptyChart()
					}
				} catch (e) {
					this.renderEmptyChart()
				}
			},
			// 表头高亮保持
			handleHeadAddClass({
				column
			}) {
				// console.log(column)
				if (this.sortField[column.property]) {
					column.order = this.sortField[column.property]
				}
			},
			// 把表格排序的 prop 映射成服务端需要的 orderField
			mapSortPropToOrderField(prop) {
				const map = this.sortPropToOrderField || {}
				return map[prop] || prop
			},
			// 排序监听
			sortChangeFun({
				column,
				prop,
				order
			}) {
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortField[prop] === order) {
					this.sortField[prop] = null
				} else {
					this.sortField[prop] = order
				}
				this.orderBys = []
				let direction = ''
				for (const i in this.sortField) {
					if (this.sortField[i]) {
						if (this.sortField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderBys.push({
							"orderField": this.mapSortPropToOrderField(i),
							"orderType": direction
						})
					}
				}
				this.currentPage = 1
				this.queryApi.pageNum = 1
				this.queryApi['adOrderByReqs'] = this.orderBys
				this.getTableData() //调用后端查询接口
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.queryApi.pageNum = 1
				this.queryApi.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.queryApi.pageNum = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryApi = { 
					isMedia: false,
					pageNum: 1, 
					pageSize: 10,
					platformNetworkId: '',
					platformAdsId: '',
					mediaAppId: '',
					mediaCompany: '',
					os: '',
					type: '',
					appProperty: ''
				}
				this.getTableData()
				this.fetchChartData()
			},
			// 导出 table 为 Excel（与接口导出命名一致：yyyyMMdd_HHmm + 渠道分时报表对比.xlsx）
			exportToExcelFromDOM() {
				const tableRef = this.$refs.multipleTable
				if (!tableRef || !tableRef.$el) {
					this.$message.warning('表格未就绪')
					return
				}
				const tableEl = tableRef.$el
				const rows = tableEl.querySelectorAll('.el-table__body-wrapper tbody tr')
				const data = []

				const headerEls = tableEl.querySelectorAll('.el-table__header th')
				const headers = Array.from(headerEls).map((th) => th.innerText.trim())
				data.push(headers)
				// const rowData = Array.from(cells).map(cell => {
				// 	// 获取单元格内所有非隐藏元素的文本（包括 v-for 产生的多个 span）
				// 	// 简单做法：取 cell.innerText，它会自动合并所有子元素的文本
				// 	// 如果希望自定义分隔符，可以手动提取各个子元素
				// 	const spans = cell.querySelectorAll('.hobby-tag') // 你的具体 class
				// 	if (spans.length) {
				// 		return Array.from(spans).map(span => span.innerText.trim()).join('、')
				// 	}
				// 	return cell.innerText.trim()
				// })
				rows.forEach((row) => {
					const cells = row.querySelectorAll('td')
					const rowData = Array.from(cells).map((cell) => {
						const spans = cell.querySelectorAll('.updownText')
						if (spans.length) {
							// Excel 单元格内换行使用 \n（CHAR(10)）；与顿号「、」拼接相比，配合行高在表格中更易读
							return Array.from(spans)
								.map((span) => span.innerText.trim())
								.filter(Boolean)
								.join('\n')
						}
						return cell.innerText.trim()
					})
					data.push(rowData)
				})
				const ws = XLSX.utils.aoa_to_sheet(data)
				// this.applyExcelMultilineRowHeights(ws)
				const wb = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
				const fileName = `${this.getExportFileNamePrefix()}渠道分时报表对比.xlsx`
				XLSX.writeFile(wb, fileName, { cellStyles: true })
			},
			// 根据单元格内换行符数量抬高行高，便于 Excel 中多行展示（仍建议在 Excel 中开启「自动换行」以完全对齐显示）
			applyExcelMultilineRowHeights(ws) {
				const ref = ws['!ref']
				if (!ref) return
				const range = XLSX.utils.decode_range(ref)
				if (!ws['!rows']) ws['!rows'] = []
				for (let R = range.s.r; R <= range.e.r; R++) {
					let maxLines = 1
					for (let C = range.s.c; C <= range.e.c; C++) {
						const addr = XLSX.utils.encode_cell({ r: R, c: C })
						const cell = ws[addr]
						if (!cell || cell.v == null) continue
						const text = String(cell.v)
						const n = (text.match(/\n/g) || []).length
						const lines = n + 1
						if (lines > maxLines) maxLines = lines
					}
					if (maxLines > 1) {
						ws['!rows'][R] = { hpt: Math.min(409, Math.max(15, 14 * maxLines + 6)) }
					}
				}
			},
		},
	}
</script>

<style scoped>
	.searchTop{
		background: #ffffff;
		padding: 20px;
	}
	.el-form {
		align-items: center;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-bottom: 25px;
	}
	.searchTop .el-form {
		margin-bottom: 0;
	}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 0px;
	}

	.menu-right {
		margin-left: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.pagination {
		margin-top: 15px;
	}
	.chart-card{
		/* border: 1px solid #D9D9D9; */
		border-radius: 4px;
		margin: 10px 0;
		background: #ffffff;
		padding: 20px;
	}
	.card-table{
		background: #ffffff;
		padding: 20px;
	}
	.chartTitRow{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
	.chartTitle{
		font-weight: 600;
		font-size: 16px;
		color: #333333;
	}
	.chart-box {
		width: 100%;
		height: 450px;
	}
	.splitTimePicker{
		margin: 0 20px;
		font-size: 14px;
	}
	.el_table{
		/* margin-top: 50px; */
	}
	.paging{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
	.menu-right-table{
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.table-header-config{
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.table-header-config-toolbar{
		width: 100%;
		margin-bottom: 12px;
		padding-bottom: 10px;
		border-bottom: 1px solid #EBEEF5;
	}
	.table-header-config-item{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		margin-right: 20px;
	}
	.updownText{
		margin-bottom: 10px;
	}
	.tHeadleftTips {
		font-size: 12px;
		margin-right: 20px;
	}
	.tHeadFixedCheckList {
		flex-wrap: wrap;
		width: 50%;
	}

	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}
	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}

	.selectAppId {
		color: #999999;
		align-items: center;
	}

	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}

	.mgb0 {
		margin-bottom: 0 !important;
	}
	
</style>
